// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loading_loaderContainer__dsOCy","logoAnimation":"Loading_logoAnimation__tYN6t","dollyZoom":"Loading_dollyZoom__UU9Qe","bankName":"Loading_bankName__XbYRs"};